import React from 'react';
import '../../styles/ProductCard.css';

const SkeletonCard = () => (
  <div className="product-card skeleton-card">
    <div className="product-image-wrapper">
      <div className="skeleton skeleton-image"></div>
    </div>
    <p className="product-name skeleton skeleton-text"></p>
    <div className="price-section">
      <span className="original-price skeleton skeleton-price"></span>
      <span className="discounted-price skeleton skeleton-price"></span>
    </div>
    <hr className="product-divider" />
    <button className="buy-button skeleton skeleton-button"></button>
  </div>
);

export default SkeletonCard;
